<template>
  <div class="page_box" v-if="listBox == true">
    <div class="page_option_box">
      <!-- 监控列表 -->
      <el-page-header
        @back="$Common.pageJump('/food_system', 3)"
        content="食品制度模板"
      >
      </el-page-header>
      <el-button
            type="primary"
            plain
            size="mini"
            icon="el-icon-circle-plus-outline"
            @click="openAddBox()"
          >
            新增制度模版
          </el-button>
          <!-- <el-button
            type="danger"
            plain
            size="mini"
            icon="el-icon-circle-close"
            :disabled="selectedDataList.length == 0 ? true : false"
            @click="delDataInfo()"
          >
            删除制度模版
          </el-button> -->
    </div>
    <div class="page_table_box" >
      <div class="school_table_box">
        <el-table
          :data="responseData.list"
          height="100%"
          class="table_box"
          :header-cell-style="{ background: '#E2EEFF', color: '#474859' }"
          @selection-change="selectActionData"
        >
          <!-- <el-table-column type="selection" width="40"> </el-table-column> -->
          <el-table-column label="序号" width="80" align="center">
            <template slot-scope="scope">
              {{
                requestData.pageSize * (requestData.pageNum - 1) +
                  scope.$index +
                  1
              }}
            </template>
          </el-table-column>

          <el-table-column prop="systemName" label="制度名称"  align="center">
          </el-table-column>

          <el-table-column prop="setTime" label="制定时间"  align="center">
            <template slot-scope="rowData">
              {{ $Common.dateFormatDate(rowData.row.setTime) }}
            </template>
          </el-table-column>

          <el-table-column prop="formulator" label="制定人"  align="center"> </el-table-column>

          <el-table-column prop="revisionHistory" label="修订记录"  align="center">
          </el-table-column>

          <el-table-column label="操作"  align="center" width="180">
            <template slot-scope="scope">
              <el-link
                class="link_box"
                type="primary"
                :underline="false"
                @click="openEditBox(scope.row)"
                >编辑</el-link
              >
              <el-divider direction="vertical"></el-divider>
              <el-link
                class="link_box"
                type="primary"
                :underline="false"
                @click="delDataInfo(scope.row.id)"
              >
                删除</el-link
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination_box">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="requestData.pageNum"
          :page-size="requestData.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="responseData.total"
        >
        </el-pagination>
      </div>
    </div>

    
  </div>
  <div class="page_box" v-else-if="addBox == true">
      <div class="page_option_box" style="justify-content:center">
        新增制度模板
      </div>
      <div class="page_table_box">
        <div class="school_table_box" style="height:100%">
            <form class="form-horizontal">
              <div class="form-group">
                <label class="col-sm-1 control-label">制度名称</label>
                <div class="col-sm-10">
                  <input
                    type="text"
                    class="form-control"
                    v-model.trim="addDataInfo.systemName"
                    maxlength="50"
                  />
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-1 control-label">制定时间</label>
                <div class="col-sm-4 options_box">
                  <el-date-picker
                    v-model="addDataInfo.setTime"
                    type="date"
                    format="yyyy 年 MM 月 dd 日"
                    value-format="timestamp"
                    placeholder="请选择有效期"
                  >
                  </el-date-picker>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-1 control-label">制定人</label>
                <div class="col-sm-10">
                  <input
                    type="text"
                    class="form-control"
                    v-model.trim="addDataInfo.formulator"
                    maxlength="50"
                  />
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-1 control-label">制度内容</label>
                <div class="col-sm-10">
                  <el-input
                    type="textarea"
                    v-model.trim="addDataInfo.systemContent"
                  ></el-input>
                  <!-- <VueUeditorWrap
                    v-model="addDataInfo.systemContent"
                  ></VueUeditorWrap> -->
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-1 control-label">修订记录</label>
                <div class="col-sm-10">
                  <input
                    type="text"
                    class="form-control"
                    v-model.trim="addDataInfo.revisionHistory"
                    maxlength="200"
                  />
                </div>
              </div>
              <div
                class="form-group"
                v-if="addDataInfo.updatingFiles.length < 5"
              >
                <label class="col-sm-1 control-label">图片附件</label>
                <div class="col-sm-10">
                  <label for="img_file_one">
                    <input
                      type="file"
                      id="img_file_one"
                      @change="imgUpload($event, 1, 'img_file_one')"
                      accept="image/*"
                    />
                    <span class="btn btn-info btn-sm">
                      <i class="el-icon-circle-plus"></i>
                      点击上传
                    </span>
                    备注：可上传5张照片，单张图片大小不超过10M
                  </label>
                </div>
              </div>
              <div
                class="form-group"
                v-if="addDataInfo.updatingFiles.length >= 1"
              >
                <div class="col-sm-offset-2 col-sm-10 certificate_box">
                  <ul>
                    <li
                      v-for="(value, key) in addDataInfo.updatingFiles"
                      :key="key"
                    >
                      <div class="certificate_img_box">
                        <img
                          :src="$store.state.config.fileUrl + value"
                          alt=""
                        />
                      </div>

                      <el-button
                        type="danger"
                        plain
                        size="mini"
                        class="btn-block"
                        @click="delPicture(1, key)"
                        >删除</el-button
                      >
                    </li>
                  </ul>
                </div>
              </div>

              <div class="form-group">
                <div class="col-sm-offset-2 col-sm-10 ">
                  <el-button type="primary" size="mini" @click="addDataAction()"
                    >确定</el-button
                  >
                  <el-button
                    type="primary"
                    size="mini"
                    plain
                    @click="closeAddBox()"
                    >取消</el-button
                  >
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

    <div class="page_box" v-else-if="editBox == true">
      <div class="page_option_box" style="justify-content:center">
        编辑制度模版
      </div>
      <div class="page_table_box">
        <div class="school_table_box" style="height:100%">
            <form class="form-horizontal">
              <div class="form-group">
                <label class="col-sm-1 control-label">制度名称</label>
                <div class="col-sm-10">
                  <input
                    type="text"
                    class="form-control"
                    v-model.trim="editDataInfo.systemName"
                    maxlength="50"
                  />
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-1 control-label">制定时间</label>
                <div class="col-sm-4 options_box">
                  <el-date-picker
                    v-model="editDataInfo.setTime"
                    type="date"
                    format="yyyy 年 MM 月 dd 日"
                    value-format="timestamp"
                    placeholder="请选择有效期"
                  >
                  </el-date-picker>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-1 control-label">制定人</label>
                <div class="col-sm-10">
                  <input
                    type="text"
                    class="form-control"
                    v-model.trim="editDataInfo.formulator"
                    maxlength="50"
                  />
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-1 control-label">制度内容</label>
                <div class="col-sm-10">
                  <el-input
                    type="textarea"
                    v-model.trim="editDataInfo.systemContent"
                  ></el-input>
                  <!-- <VueUeditorWrap
                    v-model="editDataInfo.systemContent"
                  ></VueUeditorWrap> -->
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-1 control-label">修订记录</label>
                <div class="col-sm-10">
                  <input
                    type="text"
                    class="form-control"
                    v-model.trim="editDataInfo.revisionHistory"
                    maxlength="200"
                  />
                </div>
              </div>
              <div
                class="form-group"
                v-if="editDataInfo.updatingFiles.length < 5"
              >
                <label class="col-sm-1 control-label">图片附件</label>
                <div class="col-sm-10">
                  <label for="img_file_two">
                    <input
                      type="file"
                      id="img_file_two"
                      @change="imgUpload($event, 2, 'img_file_two')"
                      accept="image/*"
                    />
                    <span class="btn btn-info btn-sm">
                      <i class="el-icon-circle-plus"></i>
                      点击上传
                    </span>
                    备注：可上传5张照片，单张图片大小不超过10M
                  </label>
                </div>
              </div>
              <div
                class="form-group"
                v-if="editDataInfo.updatingFiles.length >= 1"
              >
                <div class="col-sm-offset-2 col-sm-10 certificate_box">
                  <ul>
                    <li
                      v-for="(value, key) in editDataInfo.updatingFiles"
                      :key="key"
                    >
                      <div class="certificate_img_box">
                        <img
                          :src="$store.state.config.fileUrl + value"
                          alt=""
                        />
                      </div>

                      <el-button
                        type="danger"
                        plain
                        size="mini"
                        class="btn-block"
                        @click="delPicture(2, key)"
                        >删除</el-button
                      >
                    </li>
                  </ul>
                </div>
              </div>

              <div class="form-group">
                <div class="col-sm-offset-2 col-sm-10 ">
                  <el-button
                    type="primary"
                    size="mini"
                    @click="editDataAction()"
                    >确定修改</el-button
                  >
                  <el-button
                    type="primary"
                    size="mini"
                    plain
                    @click="closeAddBox()"
                    >取消</el-button
                  >
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
</template>

<script>
import VueUeditorWrap from "vue-ueditor-wrap";
export default {
  name: "",
  components: { VueUeditorWrap },
  props: {},
  data() {
    return {
      listBox: true,
      editBox: false,
      addBox: false,
      requestData: {
        schoolId: this.$store.state.schoolId,
        pageSize: 20,
        pageNum: 1
      },
      responseData: {
        pageSize: 20,
        pageNum: 1,
        total: 0,
        pages: 0,
        list: []
      },
      selectedDataList: [],

      addDataInfo: {
        formulator: "", // 制定人
        revisionHistory: "", // 修订记录
        schoolId: this.$store.state.schoolId, // 所属学校id
        setTime: Date.parse(new Date()), // 制定时间
        systemContent: "", // 制度内容
        systemName: "", // 制度名称
        updatingFiles: [] // 附件(多个附件用逗号隔开)
      },

      editDataInfo: {
        id: "",
        formulator: "", // 制定人
        revisionHistory: "", // 修订记录
        schoolId: this.$store.state.schoolId, // 所属学校id
        setTime: Date.parse(new Date()), // 制定时间
        systemContent: "", // 制度内容
        systemName: "", // 制度名称
        updatingFiles: [] // 附件(多个附件用逗号隔开)
      }
    };
  },
  watch: {},
  computed: {},
  methods: {
    openAddBox() {
      this.listBox = false;
      this.addBox = true;
    },

    closeAddBox() {
      this.listBox = true;
      this.addBox = false;
    },
    // 删除图片
    async delPicture(cate = 1, index) {
      if (cate == 1) {
        var requestData = {
          fileName: this.addDataInfo.updatingFiles[index]
        };
        let res = await this.$Http.delFile(requestData, true);

        if (res.code == 200) {
          this.addDataInfo.updatingFiles.splice(index, 1);
        } else if (res.code == 101) {
        } else {
          this.$message({
            message: res.messsage,
            type: "error"
          });
        }
      } else {
        this.editDataInfo.updatingFiles.splice(index, 1);
      }
    },
    // 图片上传
    async imgUpload(event, cate, domId) {
      var uploadInfo = await this.$Common.fileUpload(event);
      if (uploadInfo) {
        switch (cate) {
          case 1:
            this.addDataInfo.updatingFiles.push(uploadInfo.fileUrl);
            break;
          case 2:
            this.editDataInfo.updatingFiles.push(uploadInfo.fileUrl);
            break;
        }
      }

      document.getElementById(domId).value = "";
    },
    // 编辑数据操作
    async editDataAction() {
      var newParamData = JSON.parse(JSON.stringify(this.editDataInfo));
      if (newParamData.setTime == "") {
        this.$message({
          type: "warning",
          message: "请选择制定时间"
        });
        return false;
      }
      newParamData.updatingFiles = newParamData.updatingFiles.join(",");
      newParamData.setTime = parseInt(newParamData.setTime / 1000);
      let res = await this.$Http.editFoodSystemTemplate(newParamData);
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: res.messsage
        });
        this.closeEditBox();
        this.getDataList();
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    // 新增数据操作
    async addDataAction() {
      var newParamData = JSON.parse(JSON.stringify(this.addDataInfo));
      // var newParamData = Object.assign({},this.addDataInfo)
      if (newParamData.setTime == "") {
        this.$message({
          type: "warning",
          message: "请选择制定时间"
        });
        return false;
      }
      newParamData.updatingFiles = newParamData.updatingFiles.join(",");
      newParamData.setTime = parseInt(newParamData.setTime / 1000);
      let res = await this.$Http.addFoodSystemTemplate(newParamData);
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: res.messsage
        });

        this.closeAddBox();

        this.addDataInfo = {
          formulator: "", // 制定人
          revisionHistory: "", // 修订记录
          schoolId: this.$store.state.schoolId, // 所属学校id
          setTime: Date.parse(new Date()), // 制定时间
          systemContent: "", // 制度内容
          systemName: "", // 制度名称
          updatingFiles: [] // 附件(多个附件用逗号隔开)
        };

        this.getDataList();
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    // 删除
    delDataInfo(thisId = 0) {
      this.$confirm("确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          if (thisId >= 1) {
            var requestData = {
              systemId: [thisId]
            };
          } else {
            if (this.selectedDataList.length < 1) {
              this.$message("请先选择您要删除的数据");
              return false;
            }
            var requestData = {
              systemId: this.selectedDataList
            };
          }

          let res = await this.$Http.delFoodSystemTemplate(requestData);
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: res.messsage
            });
            this.getDataList();
          } else if (res.code == 101) {
          } else {
            this.$message({
              type: "error",
              message: res.messsage
            });
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    // 获取数据列表
    async getDataList() {
      let res = await this.$Http.getFoodSystemTemplateList(
        this.requestData,
        true
      );
      if (res.code == 200) {
        this.responseData.pageSize = res.data.pageSize;
        this.responseData.pageNum = res.data.pageNum;
        this.responseData.total = res.data.total;
        this.responseData.pages = res.data.pages;
        this.responseData.list = res.data.list;
        // console.log(this.responseData.list)
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    selectActionData(selectData) {
      this.selectedDataList = [];
      selectData.forEach((element) => {
        this.selectedDataList.push(element.id);
      });

      // console.log(this.selectedDataList)
    },
    openEditBox(data) {
      this.listBox = false;
      this.editBox = true;
      this.editDataInfo = {
        id: data.id, // ID
        formulator: data.formulator, // 制定人
        revisionHistory: data.revisionHistory, // 修订记录
        setTime: Date.parse(new Date()), // 制定时间
        systemContent: data.systemContent, // 制度内容
        systemName: data.systemName, // 制度名称
        updatingFiles: data.updatingFiles ? data.updatingFiles.split(",") : [] // 制度名称
      };
      if (data.setTime > 0) {
        this.editDataInfo.setTime = data.setTime * 1000;
      }

      // console.log(this.editDataInfo)
    },

    closeEditBox() {
      this.listBox = true;
      this.editBox = false;
    },
    handleCurrentChange(val) {
      this.requestData.pageNum = val;
      this.getDataList();
    }
  },
  created() {},
  mounted() {
    this.getDataList();
  }
};
</script>
